export const trackExpressCheckout = ({
  action,
  paymentMethod,
  sourceUrl,
}: {
  action: 'show' | 'impression' | 'submit' | 'fail' | 'close'
  paymentMethod: 'paypal_instant' | 'ratepay_invoice'
  sourceUrl?: string
}) => {
  const event = {
    event: 'feature',
    action: action,
    label: `express_checkout|${paymentMethod}`,
    value: null,
    sourceUrl: sourceUrl || undefined,
  }

  return event
}
